import { Badge } from 'MaterialUIComponents';
import { faFlag as outlinedFlag } from '@fortawesome/pro-regular-svg-icons';
import { faFlag as filledFlag } from '@fortawesome/pro-solid-svg-icons';
import { IntegrationPartnerDataService } from '$State/IntegrationPartnerDataFreezerService';
import { React } from 'Imports';
import { RolesEnum, canEditByRole } from '$Externals/VerifyRole';
import { StyledIconButton } from '$Components/Shared/MaterialUIComponents/StyledIconButton';
import { UserResponse } from '$Generated/api';
import * as _ from 'lodash';
interface IFlagButtonProps {
    eventId: number | undefined;
    flaggedByUsers: Array<UserResponse>;
    onFlagVideoEvent: (eventId: number | undefined) => void;
    customBadgeClass?: string;
    customActiveClass?: string;
    widthOverride?: string;
    heightOverride?: string;
    redesignedStyleEnabled?: boolean;
}

const styles = require('$Components/Shared/FlagButton.scss') as {
    active: string;
    badge: string;
    disabledByRoleContainer: string;
    flagButton: string;
    flagIcon: string;
    flagButtonRedesigned: string;
    unflaggedIcon: string;
    outlinedFlagIcon: string;
    disabledFlagButtonRedesigned: string;
};

export const FlagButton = (props: IFlagButtonProps) => {
    let canEdit = false;

    const onFlagEvent = async (e: any): Promise<void> => {
        e.stopPropagation();
        return await props.onFlagVideoEvent(props.eventId);
    };

    const isFlaggedByCurrentUser = (): boolean => {
        return (
            _.find(props.flaggedByUsers, (user: UserResponse) => {
                return user.integrationProviderSourceId === IntegrationPartnerDataService.getState().currentUserResult.data.id;
            }) !== undefined
        );
    };

    const eventFlaggedByOtherUsersList = _.filter(props.flaggedByUsers, (user: UserResponse) => {
        return user.integrationProviderSourceId !== IntegrationPartnerDataService.getState().currentUserResult.data.id;
    });

    const getComplementaryDescription = () => {
        const numberFlaggedByOthers = eventFlaggedByOtherUsersList.length;
        const singularDescription = (isFlaggedByCurrentUser: boolean) => (isFlaggedByCurrentUser ? 'other' : 'person');
        const pluralDescription = (isFlaggedByCurrentUser: boolean) => (isFlaggedByCurrentUser ? 'others' : 'people');
        const description = (numberFlaggedBy: number, isFlaggedByCurrentUser: boolean) =>
            numberFlaggedBy > 1 ? pluralDescription(isFlaggedByCurrentUser) : singularDescription(isFlaggedByCurrentUser);
        return `${numberFlaggedByOthers} ${description(numberFlaggedByOthers, isFlaggedByCurrentUser())}`;
    };

    const getDescription = (): string | undefined => {
        let description = undefined;
        if (props.flaggedByUsers.length > 0) {
            if (isFlaggedByCurrentUser()) {
                description = 'Flagged by you';
                if (eventFlaggedByOtherUsersList.length > 0) {
                    description += ` and ${getComplementaryDescription()}`;
                }
            } else {
                description = `Flagged by ${getComplementaryDescription()}`;
            }
        }

        return description;
    };

    canEdit = canEditByRole([RolesEnum.videoEventEdit, RolesEnum.encompassVideo]);
    const description = getDescription();

    const iconForButton = props.redesignedStyleEnabled
        ? isFlaggedByCurrentUser()
            ? filledFlag
            : !canEdit && props.flaggedByUsers.length > 0
              ? filledFlag
              : outlinedFlag
        : filledFlag;

    const iconStylesForButton = props.redesignedStyleEnabled
        ? props.flaggedByUsers.length === 0
            ? styles.unflaggedIcon
            : isFlaggedByCurrentUser()
              ? styles.flagIcon
              : eventFlaggedByOtherUsersList.length > 0
                ? styles.outlinedFlagIcon
                : styles.flagIcon
        : styles.flagIcon;

    return (
        <div
            className={
                !canEdit
                    ? styles.disabledByRoleContainer
                    : isFlaggedByCurrentUser()
                      ? [styles.active, props.customActiveClass || ''].join(' ')
                      : ''
            }
        >
            <Badge
                classes={{ badge: [styles.badge, props.customBadgeClass || ''].join(' ') }}
                badgeContent=""
                variant="dot"
                invisible={eventFlaggedByOtherUsersList.length === 0 || (props.flaggedByUsers.length === 1 && isFlaggedByCurrentUser())}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <StyledIconButton
                    icon={iconForButton}
                    iconStyles={iconStylesForButton}
                    className={
                        props.redesignedStyleEnabled
                            ? canEdit
                                ? styles.flagButtonRedesigned
                                : styles.disabledFlagButtonRedesigned
                            : styles.flagButton
                    }
                    title={description ? description : 'Not Flagged'}
                    isDisabled={!canEdit || false}
                    handleOnClick={onFlagEvent}
                    heightOverride={props.heightOverride}
                    widthOverride={props.widthOverride}
                ></StyledIconButton>
            </Badge>
        </div>
    );
};

// TODO Remove component when split eventDetailsRedesign (event_details_redesign) is cleaned up
